import React, { useState } from "react";
import "./FaqSection.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

const faqData = [
  {
    question: "What kind of services do you actually handle?",
    answer:
      "We support everyday business essentials: printer support, Microsoft 365, antivirus & security, web development, CRM setups, and basic accounting tools. You can start with one area and expand later.",
  },
  {
    question: "How quickly do you typically respond to issues?",
    answer:
      "For critical issues, we usually respond within a few business hours. Most tickets are acknowledged the same day and resolved within 24–48 hours depending on complexity.",
  },
  {
    question: "Can you work with our existing tools and providers?",
    answer:
      "Yes. We often plug into existing software stacks—whether it’s your current CRM, accounting tool, hosting provider, or email setup—and improve what’s already there instead of forcing a full switch.",
  },
  {
    question: "Is there a long-term contract or minimum commitment?",
    answer:
      "No long lock-ins. Most clients start on a monthly or project-based engagement. If we’re a good fit, we can always move to a longer-term support or retainer plan later.",
  },
  {
    question: "Do you offer on-site help or only remote support?",
    answer:
      "Our primary mode is remote support, which covers most issues quickly. For specific cases where on-site work is needed, we discuss it in advance based on your location and requirements.",
  },
  {
    question: "How do we get started?",
    answer:
      "Just reach out with a quick overview of your setup and priorities. We’ll schedule a short call, share a simple plan with pricing, and you decide how you’d like to move forward.",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="faq-section">
      <div className="faq-inner">
        <div className="faq-header">
          <span className="faq-pill">FAQ & Support</span>
          <h2>Answers for growing teams.</h2>
          <p>
            A quick overview of how we work, what’s included, and what you can
            expect day to day. Still unsure?{" "}
            <a href="/contact">Send us your questions</a> and we’ll reply within
            one business day.
          </p>
        </div>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <motion.div
              key={index}
              className={`faq-item ${openIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: index * 0.04 }}
            >
              <div className="faq-question">
                <h4>{faq.question}</h4>
                <div className="faq-icon-wrap">
                  <FaChevronDown
                    className={`icon ${openIndex === index ? "rotate" : ""}`}
                  />
                </div>
              </div>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    className="faq-answer"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.25 }}
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
